module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14XDsBj/tc-custom/9781398455191.jpg?1682168954032",
      "alt": "This image is the cover for the book Piano Fingers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Piano Fingers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Damien touches the keys of the old brown piano, he is filled with a sudden desire to play like never before. As he performs, the instrument seems to glow with magic, and Damien feels a new level of consciousness rise within him. Inspired by true events, this lively story blends elements of music, magic, and fantasy to create an uplifting tale that will appeal to both children and adults. As Damien’s passion for the piano grows, he discovers a whole new world of possibility and wonder. Inspired by true events. “In telling this lively story, you have effectively blended a few of the most uplifting elements of art such as music, magic, and fantasy. Your story will definitely appeal to both children and adults” – Papertrue")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Claire Middleton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When she’s not writing, author Claire Middleton enjoys a variety of photography and art, life coaching and modelling as well as singing and dancing in any spare time she finds! Blue Diamond Elevation, founded in 2023, brings together Claire’s passions in a business designed to uplift and empower others. “I love working with spirit to spread a little magic and help people find their spark.” Website: www.bluediamondelevation.com [http://www.bluediamondelevation.com] YouTube: Claire's School of Photography")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0